import React, { useState, useEffect, Fragment } from "react";
import PageContainerWithMenu from "../../../containers/PageContainerWithMenu";
import { Grid, Typography } from "@mui/material";
import SelectChipCarriers from "./components/SelectChipCarriers";
import PlainMenu from "../../PlainMenu";
import SelectChipContractStatuses from "./components/SelectChipContractStatuses";
import ModalMyAgents from "./components/ModalMyAgents";
import SelectChipLevels from "./components/SelectChipLevels";
import SelectAgencyGroups from "./components/SelectAgencyGroups";
import TabAgents from "./components/TabAgents";
import ButtonReset from "./components/ButtonReset";
import PopperNotes from "./components/PopperNotes";
import Card from "@mui/material/Card";
import { useDispatch, useSelector } from "react-redux";
import ButtonSendNotification from "./components/ButtonSendNotification";
import { setReadyToSellFilterModel } from "../../../store/actions/agents/readyToSell";
import { setAgentsReadyToSellInfoFilterModel } from "../../../store/actions/agents/agentsReadyToSellInfo";
import ButtonResetIconOnly from "./components/ButtonResetIconOnly";

const AgentInfo = (props) => {
  const [checkedCarrierValues, setCheckedCarrierValues] = useState([]);
  const [checkedLevelValues, setCheckedLevelValues] = useState([]);
  const [checkedContractStatusValues, setCheckedContractStatusValues] =
    useState([]);
  const [isSendNotificationOpen, setIsSendNotificationOpen] = useState(false);
  const [allCarrierValues, setAllCarrierValues] = useState([]);
  const [allLevelValues, setAllLevelValues] = useState([]);
  const [allContractStatusValues, setAllContractStatusValues] = useState([]);
  const [allAgencyGroupValues, setAllAgencyGroupValues] = useState([]);
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [agencyId, setAgencyId] = useState("");
  const readyToSellData = useSelector((state) => state.readyToSell.data);
  const agentsReadyToSellInfoData = useSelector(
    (state) => state.agentsReadyToSellInfo.data
  );
  const agentsContractInfoData = useSelector(
    (state) => state.agentsContractInfo.data
  );
  const agentData = useSelector((state) => state.agents.data);
  const [tabCheck, setTabCheck] = useState("one");
  const dispatch = useDispatch();

  useEffect(() => {
    if (agencyId === "") {
      setAgencyId(sessionStorage.getItem("agencyId"));
      setData(agentData);
    } else if (agencyId === 'undefined'){
      setData(agentData);
    } else {
      setData(agentData.filter((row) => row.agencyId === agencyId));
    }
  }, [agentData, agencyId]);

  useEffect(() => {
    if (data.length > 0) {
      setFilteredData(data);
    }
  }, [data, agencyId]);

  useEffect(() => {
    if (data.length > 0) {
      setIsLoading(true);
      let results = [...data]; 

      const filterResultsArray = (checkedValues, key) => {
        if (checkedValues && checkedValues.length > 0) {
          results = results.filter((row) => checkedValues.includes(row[key]));
        }
      };

      filterResultsArray(checkedCarrierValues, "carrierName");
      filterResultsArray(checkedLevelValues, "agentLevel");
      filterResultsArray(checkedContractStatusValues, "contractStatus");
      setFilteredData(results);
      setIsLoading(false);
    }
  }, [
    data,
    agencyId,
    checkedCarrierValues,
    checkedLevelValues,
    checkedContractStatusValues,
  ]);

  useEffect(() => {
    const getContractStatusValue = () => {
      const contractStatusValue =
        props.location.state.state.contractStatusValue;

      switch (contractStatusValue.toUpperCase()) {
        case "APPROVED":
          return ["APPROVED", "APPROVED_NOT_SELLING"];
        case "APPROVED - TOTAL":
          return ["APPROVED", "APPROVED_NOT_SELLING"];
        case "APPROVED - INTENT TO MOVE AWAY SUBMITTED":
          return ["APPROVED_INTENT_TO_MOVE_AWAY_SUBMITTED"];
        case "APPROVED - RELEASED":
          return ["APPROVED_RELEASING"];
        case "INTENT TO MOVE":
          return ["INTENT_MOVE_BIG"];
        case "IN PROCESS":
          return [
            "PENDING_WRITING",
            "RECEIVED NOT SUBMITTED",
            "SUBMITTED",
            "SUBMITTED_MISSING_DOC",
            "SUBMITTED_NO_CERT",
          ];
        case "SENT TO AGENT":
          return ["SENT_TO_AGENT"];
        case "TERMINATED":
          return ["TERMINATED (SELF RELEASE)"];
        case "WITHDRAWN":
          return [
            "WITHDRAWN",
            "WITHDRAWN (CARRIER DENIED)",
            "WITHDRAWN (FAILED TO CERTIFY)",
            "WITHDRAWN (INCOMPLETE/NON-RESPONSIVE)",
          ];
        default:
          return [];
      }
    };
    const createSetFromFilteredData = (key) =>
      [...new Set(filteredData.map((row) => row[key]))].filter(
        (value) => value !== null && value !== "" && value !== undefined
      );
    const createSetFromFilteredDataAndIndex = (key, idKey) => {
      const uniqueData = filteredData.reduce((acc, row) => {
        if (
          !acc.find((item) => item.id === row[idKey] && item.value === row[key])
        ) {
          acc.push({ id: row[idKey], value: row[key] });
        }
        return acc.sort((a, b) =>
          String(a.value).localeCompare(String(b.value))
        );
      }, []);

      return uniqueData.filter(
        (item) =>
          item.value !== null && item.value !== "" && item.value !== undefined
      );
    };

    if (allCarrierValues.length === 0 && filteredData.length > 0) {
      setAllCarrierValues(createSetFromFilteredData("carrierName"));
    }
    if (allLevelValues.length === 0 && filteredData.length > 0) {
      setAllLevelValues(createSetFromFilteredData("agentLevel"));
    }
    if (allContractStatusValues.length === 0 && filteredData.length > 0) {
      setAllContractStatusValues(createSetFromFilteredData("contractStatus"));
      if (props.location.state !== undefined) {
        setCheckedContractStatusValues(getContractStatusValue());
      }
    }
    if (allAgencyGroupValues.length === 0 && filteredData.length > 0) {
      setAllAgencyGroupValues(
        createSetFromFilteredDataAndIndex("agencyName", "agencyId")
      );
    }
  }, [
    filteredData,
    allAgencyGroupValues,
    allCarrierValues,
    allLevelValues,
    allContractStatusValues,
    props.location.state,
    data,
  ]);

  useEffect(() => {
    const getMaxYear = (readyToSellData) => {
      const years = readyToSellData.map((row) => row.planYear);
      const uniqueYears = [...new Set(years)]; // Use Set to get unique years
      return Math.max(...uniqueYears);
    };

    const maxYear = getMaxYear(readyToSellData); // Call the function with the data

    dispatch(
      setReadyToSellFilterModel({
        items: [
          {
            id: 0,
            field: "planYear",
            operator: "equals",
            value: maxYear.toString(), // Use the result of the function call
          },
        ],
      })
    );
  }, [dispatch, readyToSellData]);

  useEffect(() => {
    const getMaxYear = (agentsReadyToSellInfoData) => {
      const years = agentsReadyToSellInfoData.map((row) => row.planYear);
      const uniqueYears = [...new Set(years)]; // Use Set to get unique years
      return Math.max(...uniqueYears);
    };

    const maxYear = getMaxYear(agentsReadyToSellInfoData); // Call the function with the data

    dispatch(
      setAgentsReadyToSellInfoFilterModel({
        items: [
          {
            id: 0,
            field: "planYear",
            operator: "equals",
            value: maxYear.toString(),
          },
        ],
      })
    );
  }, [dispatch, agentsReadyToSellInfoData]);

  const SelectChipWrapper = ({
    Component,
    records,
    checkedValues,
    setCheckedValues,
    ...props
  }) => (
    <Component
      records={records.sort((a, b) => String(a).localeCompare(String(b)))}
      checkedValues={checkedValues}
      setCheckedValues={setCheckedValues}
      {...props}
    />
  );

  return (
    <Fragment>
      <PageContainerWithMenu
        data-tour="ad__home"
        type="agents"
        HasMenu={true}
        menu={
          <PlainMenu
            title="My Agents"
            submenu={
              <Grid
                container
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "left",
                  alignItems: "left",
                  height: "100%",
                }}
              >
                {!isLoading && (
                  <Fragment>
                    {tabCheck === "one" && (
                      <Card
                        style={{
                          margin: "5px",
                          background: "transparent",
                          color: "black",
                          size: "md",
                          varient: "outlined",
                          alignContent: "left",
                          width: "100%",
                          paddingLeft: "70px",
                        }}
                      >
                        <Fragment>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              marginBottom: "-15px",
                              justifyContent: "left",
                              marginleft: "1px",
                              width: "100%",
                            }}
                          >
                            {"Carriers"}
                          </div>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              marginBottom: "-15px",
                              justifyContent: "left",
                              width: "100%",
                            }}
                          >
                            <SelectChipWrapper
                              Component={SelectChipCarriers}
                              records={allCarrierValues}
                              checkedValues={checkedCarrierValues}
                              setCheckedValues={setCheckedCarrierValues}
                            />
                            <ButtonResetIconOnly
                              setCheckedCarrierValues={setCheckedCarrierValues}
                              type="carrier"
                              disabled={checkedCarrierValues.length === 0}
                            />
                          </div>

                          <Typography
                            style={{
                              display: "flex",
                              alignItems: "center",
                              marginBottom: "-15px",
                              marginTop: "10px",
                              justifyContent: "left",
                            }}
                          >
                            Contract Status
                          </Typography>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              marginBottom: "-15px",
                              justifyContent: "left",
                            }}
                          >
                            <SelectChipWrapper
                              Component={SelectChipContractStatuses}
                              records={allContractStatusValues}
                              checkedValues={checkedContractStatusValues}
                              setCheckedValues={setCheckedContractStatusValues}
                            />
                            <ButtonResetIconOnly
                              setCheckedContractStatusValues={
                                setCheckedContractStatusValues
                              }
                              type="contract"
                              disabled={
                                checkedContractStatusValues.length === 0
                              }
                            />
                          </div>

                          <Typography
                            style={{
                              display: "flex",
                              alignItems: "center",
                              marginBottom: "-15px",
                              marginTop: "10px",
                              justifyContent: "left",
                            }}
                          >
                            Levels
                          </Typography>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              marginBottom: "-15px",
                              justifyContent: "left",
                            }}
                          >
                            <SelectChipWrapper
                              Component={SelectChipLevels}
                              records={allLevelValues}
                              checkedValues={checkedLevelValues}
                              setCheckedValues={setCheckedLevelValues}
                            />
                            <ButtonResetIconOnly
                              setCheckedLevelValues={setCheckedLevelValues}
                              type="level"
                              disabled={checkedLevelValues.length === 0}
                            />
                          </div>
                          <Typography
                            style={{
                              display: "flex",
                              alignItems: "center",
                              marginBottom: "-15px",
                              marginTop: "10px",
                              justifyContent: "left",
                            }}
                          >
                            Agency Groups
                          </Typography>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              marginBottom: "-15px",
                              justifyContent: "left",
                              width: "100%",
                            }}
                          >
                            <SelectAgencyGroups
                              records={allAgencyGroupValues}
                              agencyId={agencyId}
                              setAgencyId={setAgencyId}
                            />
                            <ButtonResetIconOnly
                              setAgencyId={setAgencyId}
                              type="agencyGroup"
                              disabled={
                                agencyId === sessionStorage.getItem("agencyId")
                              }
                            />
                          </div>

                          <div
                            style={{
                              width: "100%",
                              display: "flex",
                              justifyContent: "left",
                              marginBottom: "-15px",
                            }}
                          >
                            <ButtonReset
                              setCheckedCarrierValues={setCheckedCarrierValues}
                              setCheckedLevelValues={setCheckedLevelValues}
                              setCheckedContractStatusValues={
                                setCheckedContractStatusValues
                              }
                              setAgencyId={setAgencyId}
                              disabled={
                                agencyId ===
                                  sessionStorage.getItem("agencyId") &&
                                checkedCarrierValues.length === 0 &&
                                checkedLevelValues.length === 0 &&
                                checkedContractStatusValues.length === 0
                              }
                            />
                          </div>
                          <div
                            style={{
                              width: "100%",
                              display: "flex",
                              justifyContent: "left",
                              marginBottom: "-10px",
                            }}
                          >
                            <ButtonSendNotification
                              isOpen={isSendNotificationOpen}
                              setIsOpen={setIsSendNotificationOpen}
                              filteredAgents={filteredData}
                            />
                          </div>
                        </Fragment>
                      </Card>
                    )}
                    <PopperNotes />
                  </Fragment>
                )}
              </Grid>
            }
          />
        }
        content={
          <TabAgents
            filteredData={filteredData}
            checkedCarrierValues={checkedCarrierValues}
            checkedContractStatusValues={checkedContractStatusValues}
            checkedLevelValues={checkedLevelValues}
            agencyId={agencyId}
            setTabCheck={setTabCheck}
            agentsContractInfoData={agentsContractInfoData}
            isAgentDataLoading={isLoading}
          />
        }
      />
      <ModalMyAgents />
    </Fragment>
  );
};

export default AgentInfo;
